import { render, staticRenderFns } from "./FaqEditForm.vue?vue&type=template&id=94154664"
import script from "./FaqEditForm.vue?vue&type=script&lang=js"
export * from "./FaqEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports